import { Component } from '@angular/core';

@Component({
  selector: 'demo-typography',
  templateUrl: './typography.component.html',
  styleUrls: ['./typography.component.scss'],
  standalone: false,
})
export class DemoTypographyComponent {}
